import React from 'react';

export default function CoinLogo({ size = 40, className = '' }) {
  // 25% larger than requested size
  const displaySize = Math.round(size * 1.25);
  return (
    <img
      src="/ch-main-logo.png"
      alt="CoinHustle Exchange"
      width={displaySize}
      height={displaySize}
      className={`object-contain ${className}`}
      style={{ width: displaySize, height: displaySize }}
    />
  );
}
